import store from '@/store'
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'

@Module({
  dynamic: true,
  name: 'UiHomeModule',
  store,
  namespaced: true
})
class HomeModule extends VuexModule {
  homeSelectIndexPath = ''
  showAdminName = false

  /**
   *  保存学员中心主页选择的TAB路径
   * @param ctx
   * @param index
   */
  @Action
  setHomeIndex(index: string) {
    this.SET_HOME_INDEX(index)
  }

  @Mutation
  SET_HOME_INDEX(index: string) {
    this.homeSelectIndexPath = index
  }

  /**
   *  保存学员中心主页选择的TAB路径
   * @param ctx
   * @param index
   */
  @Action
  setShow(isshow: boolean) {
    this.SET_SHOW(isshow)
  }

  @Mutation
  SET_SHOW(isshow: boolean) {
    this.showAdminName = isshow
  }
}

export default getModule(HomeModule)
